// project-imports
import { deleteRequest, getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - CUSTOMERS ||============================== //

export async function handleCustomers(action: APIAction) {
  switch (action.method) {
    case 'read':
      return getRequest(`/customers/${action.id}?agent-id=${action.data.agentId}`);
    case 'read-list':
      return getRequest(`/customers?agent-id=${action.id}`);
    case 'create':
      return postRequest('/customers', action.data);
    case 'update':
      return putRequest(`/customers/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/customers/${action.id}`);
    case 'create-sales-service':
      return postRequest(`/customers/${action.id}/sales-service`, action.data);
    case 'read-offers':
      return (async () => {
        try {
          // Primera llamada para obtener el total de páginas
          const firstResponse = await getRequest(`/customers/${action.id}/offers?page=1`);

          if (!firstResponse || !firstResponse.items) {
            throw new Error('Error fetching data');
          }

          const totalPages = firstResponse.total_pages;
          let allItems = [...firstResponse.items];

          // Si hay más páginas, realizar llamadas adicionales
          if (totalPages > 1) {
            const requests = [];
            for (let page = 2; page <= totalPages; page++) {
              requests.push(getRequest(`/customers/${action.id}/offers&?page=${page}`));
            }

            const responses = await Promise.all(requests);
            responses.forEach((res) => {
              if (res && res.items) {
                allItems = allItems.concat(res.items);
              }
            });
          }

          return { items: allItems, total_items: allItems.length }; // Devuelve todos los items
        } catch (error) {
          console.error('Error fetching paginated data:', error);
          return { items: [], total_items: 0 };
        }
      })();
    default:
      console.info('[ApiManager > handleApiAction > handleCustomers] - Unknown method');
      break;
  }
}
